import { render, staticRenderFns } from "./officialAccountList.vue?vue&type=template&id=6a576644&scoped=true&"
import script from "./officialAccountList.vue?vue&type=script&lang=js&"
export * from "./officialAccountList.vue?vue&type=script&lang=js&"
import style0 from "./officialAccountList.vue?vue&type=style&index=0&id=6a576644&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a576644",
  null
  
)

export default component.exports